// /resources/js/app.js

import './bootstrap';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import intersect from '@alpinejs/intersect';

// --- V2 Dashboard Imports ---
import { v2StateManager } from './app/modules/v2/app/V2StateManager.js';
import { v2UIManager } from './app/modules/v2/app/V2UIManager.js';
import { v2ActionHandler } from './app/modules/v2/app/V2ActionHandler.js';

window.Alpine = Alpine;

// --- DEFINE ALL ALPINE COMPONENTS HERE ---
document.addEventListener('alpine:init', () => {
    
    // Component for the main layout (header, drawer)
    Alpine.data('app', () => ({
        isDrawerOpen: false,
        showNotificationsModal: false,
        openNotifications() {
            this.showNotificationsModal = true;
            if (window.SGNL && window.SGNL.notifications) {
                window.SGNL.notifications.fetchAndRender();
                window.SGNL.notifications.markAsRead();
            }
        },
    }));

    // Component for reusable unlock modals
    Alpine.data('unlockModals', () => ({
        showGuest: false,
        showInsufficient: false,
        showConfirmation: false,
        isUnlocking: false,
        confirmationMessage: '',
        callToUnlock: null,
        openUnlockFlow(detail) {
            this.callToUnlock = detail;
            const user = window.SGNL.user;
            const isGuest = !user;
            if (isGuest) { this.showGuest = true; return; }
            if (user.points_balance < this.callToUnlock.cost) { this.showInsufficient = true; return; }
            this.confirmationMessage = `Are you sure you want to spend ${this.callToUnlock.cost} points to unlock signal #${this.callToUnlock.call_id}?`;
            this.showConfirmation = true;
        },
        async confirmUnlock() {
            if (this.isUnlocking || !this.callToUnlock) return;
            this.isUnlocking = true;
            try {
                const response = await window.axios.post(`/api/signals/${this.callToUnlock.call_id}/unlock`);
                const user = window.SGNL.user;
                user.points_balance -= this.callToUnlock.cost;
                document.getElementById('points-balance-display').textContent = user.points_balance.toLocaleString();
                window.dispatchEvent(new CustomEvent('signal-unlocked', { detail: { callId: this.callToUnlock.call_id, unlockedCallData: response.data.call } }));
                this.close();
            } catch (error) {
                this.confirmationMessage = error.response?.data?.message || 'An unexpected error occurred.';
            } finally { this.isUnlocking = false; }
        },
        close() {
            this.showGuest = false;
            this.showInsufficient = false;
            this.showConfirmation = false;
            this.callToUnlock = null;
        }
    }));

    // Component for the V2 Dashboard
    Alpine.data('v2_dashboard', () => ({
        state: v2StateManager,
        ui: v2UIManager,
        actions: v2ActionHandler,
        handleFilterToggle() {
            v2StateManager.showUnlockedOnly = !v2StateManager.showUnlockedOnly;
            window.dispatchEvent(new CustomEvent('state-change'));
            this.actions.loadActiveStream(1);
        },
        init() {
            // Only initialize the V2 controllers if the dashboard element exists on the page.
            if (document.getElementById('v2-feed-container')) {
                this.ui.init();
                this.actions.init();
                window.addEventListener('state-change', () => {
                    this.state = { ...v2StateManager };
                });
            }
        }
    }));
});

// --- START ALPINE ---
Alpine.plugin(collapse);
Alpine.plugin(intersect);
Alpine.start();